// extracted by mini-css-extract-plugin
module.exports = {"ContainerGeneralChat":"ChatContainer_ContainerGeneralChat__36nZq","ChatContainer":"ChatContainer_ChatContainer__1X6_O"};